// client/src/coms/views/canvas_parts/CanvasAnimationPanel.js
import React from 'react';

function AnimationButton({ children, onClick, disabled, danger }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        minHeight: 32,
        borderRadius: 7,
        border: danger ? '1px solid rgba(248,113,113,0.34)' : '1px solid rgba(255,255,255,0.12)',
        background: disabled ? 'rgba(255,255,255,0.035)' : danger ? 'rgba(127,29,29,0.24)' : 'rgba(255,255,255,0.075)',
        color: disabled ? 'rgba(255,255,255,0.34)' : danger ? 'rgba(255,235,235,0.98)' : 'rgba(245,247,250,0.94)',
        padding: '0 9px',
        fontSize: 12,
        fontWeight: 900,
        cursor: disabled ? 'default' : 'pointer',
      }}
    >
      {children}
    </button>
  );
}

export default function CanvasAnimationPanel({
  enabled,
  isOwner,
  frames,
  activeFrameId,
  onEnableAnimation,
  onDisableAnimation,
  onAddFrame,
  onDeleteFrame,
  onSelectFrame,
}) {
  const safeFrames = Array.isArray(frames) ? frames.filter(Boolean) : [];

  if (!enabled) {
    return (
      <div style={{ display: 'grid', gap: 10, fontSize: 12, lineHeight: 1.4 }}>
        <div style={{ fontSize: 13, fontWeight: 900 }}>Animation mode is off</div>
        <div style={{ color: 'rgba(255,255,255,0.68)' }}>
          The canvas owner can enable animation for everyone connected to this canvas.
        </div>
        <AnimationButton onClick={onEnableAnimation} disabled={!isOwner}>Turn on animation</AnimationButton>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, minHeight: 0 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        <AnimationButton onClick={onAddFrame}>+ Frame</AnimationButton>
        <AnimationButton onClick={onDisableAnimation} disabled={!isOwner} danger>Disable</AnimationButton>
      </div>

      <div style={{ color: 'rgba(255,255,255,0.66)', fontSize: 11, lineHeight: 1.4 }}>
        Every frame stores its own complete canvas state. Local and remote edits are saved into the active frame for everyone.
      </div>

      <div style={{ display: 'grid', gap: 6, minHeight: 0, overflow: 'auto' }}>
        {safeFrames.map((frame, index) => {
          const active = String(frame.id) === String(activeFrameId);
          return (
            <div
              key={frame.id || index}
              style={{
                display: 'grid',
                gridTemplateColumns: 'minmax(0, 1fr) 34px',
                gap: 6,
              }}
            >
              <button
                type="button"
                onClick={() => onSelectFrame && onSelectFrame(frame.id)}
                style={{
                  minHeight: 38,
                  borderRadius: 8,
                  border: active ? '1px solid rgba(96,165,250,0.72)' : '1px solid rgba(255,255,255,0.10)',
                  background: active ? 'rgba(59,130,246,0.22)' : 'rgba(0,0,0,0.16)',
                  color: 'rgba(245,247,250,0.95)',
                  padding: '0 10px',
                  textAlign: 'left',
                  fontSize: 12,
                  fontWeight: active ? 950 : 850,
                  cursor: 'pointer',
                }}
              >
                {frame.name || `Frame ${index + 1}`}
              </button>
              <button
                type="button"
                onClick={() => onDeleteFrame && onDeleteFrame(frame.id)}
                disabled={safeFrames.length <= 1}
                title="Delete frame"
                style={{
                  minHeight: 38,
                  borderRadius: 8,
                  border: '1px solid rgba(248,113,113,0.28)',
                  background: safeFrames.length <= 1 ? 'rgba(255,255,255,0.03)' : 'rgba(127,29,29,0.22)',
                  color: safeFrames.length <= 1 ? 'rgba(255,255,255,0.25)' : 'rgba(255,235,235,0.96)',
                  fontWeight: 900,
                  cursor: safeFrames.length <= 1 ? 'default' : 'pointer',
                }}
              >
                ×
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
